export default [
  {
    path: "/tarifas",
    component: () => import("@/views/tarifas/Listar.vue"),
  },
  {
    path: "/tarifas/crear",
    component: () => import("@/views/tarifas/Crear.vue"),
  },
  {
    path: "/tarifas/editar/:id",
    component: () => import("@/views/tarifas/Editar.vue"),
  },
];
